//export const base_url = 'http://localhost:5000/';
// export const base_url = 'http://54.86.222.135/';
// https://api.ozalpha.com/api/v1/user/signup
export const base_url = 'https://api.ozalpha.com/';
export const base_version = 'api/v1/'